import React from 'react';
import { useTranslation } from 'react-i18next';

const useLocale = () => {
    const { i18n } = useTranslation();
    
    const setLocaleOption = React.useCallback((locale) => {
        if (locale) {
            const formattedLocale = locale.replace('_', '-');
            i18n.changeLanguage(formattedLocale);
        }
    }, [i18n]);
    
    return {
        setLocaleOption,
        locale: i18n.language,
    };
};

export default useLocale;
